var _excluded = ["heading", "buttonLabel", "onScrollEnd", "loading", "loadingMore", "children", "enablePagination", "onShowMoreClick"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState, useRef, useMemo } from 'react';
import { Button, Heading, SkeletonText, Spinner } from '../../../components';
import { tqc, useMultiStyleConfig } from '../../../system';
import { getValidChildren } from '../../../utils';
import { useIntersectCallback } from './useIntersectCallback';
export var ActivityFeed = props => {
  var {
      heading = 'Activity Feed',
      buttonLabel = 'Show more',
      onScrollEnd,
      loading = false,
      loadingMore = false,
      children,
      enablePagination,
      onShowMoreClick
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var [isExpanded, setIsExpanded] = useState(false);
  var ulRef = useRef(null);
  var liRef = useRef(null);
  var {
    list,
    spinner
  } = useMultiStyleConfig('ActivityFeed', rest);
  var listStyles = _objectSpread({
    listStyle: 'none',
    overflowY: 'auto'
  }, list);
  useIntersectCallback({
    target: liRef,
    root: ulRef,
    callback: onScrollEnd,
    isExpanded
  });

  //possibly expensive if there are a lot of child elements (which probably will be the case)

  var validChildren = useMemo(() => getValidChildren(children), [children]);
  return /*#__PURE__*/React.createElement(tqc.section, null, heading ? /*#__PURE__*/React.createElement(Heading, {
    size: "md",
    marginBottom: "1.875rem",
    as: "h1"
  }, heading, ' ') : null, /*#__PURE__*/React.createElement(tqc.ul, _extends({
    ref: ulRef,
    __css: listStyles
  }, rest), validChildren, loading && /*#__PURE__*/React.createElement(SkeletonText, {
    noOfLines: 15,
    key: "activity-feed-skeleton"
  }), loadingMore && /*#__PURE__*/React.createElement(tqc.li, {
    __css: spinner
  }, /*#__PURE__*/React.createElement(Spinner, {
    thickness: "8px"
  })), isExpanded && /*#__PURE__*/React.createElement(tqc.li, {
    ref: liRef,
    opacity: 0,
    height: "5px",
    className: "intersection-threshold"
  })), /*#__PURE__*/React.createElement(tqc.div, {
    paddingTop: "8px"
  }, !isExpanded && enablePagination && /*#__PURE__*/React.createElement(Button, {
    size: "xs",
    variant: "tertiary",
    onClick: () => {
      setIsExpanded(true);
      if (onShowMoreClick) {
        onShowMoreClick();
      }
    }
  }, buttonLabel)));
};